import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom'
import { Container, Button, Icon, Image, Grid, Divider, Input } from 'semantic-ui-react'
import { Helmet } from "react-helmet"
import { toast, ToastContainer } from 'react-toastify';

import app from 'ampersand-app';

import { useTimerControls } from "xAppLib/Timer/TimerContext";
import TimerDisplay from "xAppLib/Timer/TimerDisplay";

import Leaderboard from 'views/leaderboard/Leaderboard'

import { WORDS_DICT } from "cont/words.js";

const DEBUG = false;

//	=====	========================================================	========================================================	====

export function WordleWordRes({ word, res }) {
	return <span className="letter-row">
				{ Array.from({ length: word?.length }).
						map( (_, i) => <span key={i} className={"letter-box mini " + (res?.[i]=='2' && 'lett-green' || res?.[i]=='1' && 'lett-yellow' || res?.[i]=='0' && 'lett-grey') } >{word?.[i]}</span> ) 
				}
		</span>;
}

//	=====	========================================================	========================================================	====

const Wordle = (game_pars) => {


	// console.log('Wordle', game_pars);

	const GAME_WORD = game_pars.word || WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)];
	const NUMBER_OF_GUESSES = game_pars.max_guesses || 5;
	const WORD_LENGTH = game_pars.word_length || GAME_WORD.length;
	const DICT = game_pars.dict ?? false;

	const ON_CHECK = game_pars.onCheck;
	const ON_STAT = game_pars.onStat;

	const KEYB_LISTN = game_pars.keyb_listn ?? true;

	const SHOW_INP_FLD = game_pars.show_inp_fld ?? false;
	const SHOW_INP_BXS = game_pars.show_inp_bxs ?? true;

	let [curr_guess, setCurr_guess] = useState('');
	let [guess_arr, setGuess_arr] = useState([]);
	let [stat, setStat] = useState('guessing');
	let [used_letts, setUsed_letts] = useState({});

	const { Timer_start, Timer_stop, Timer_now, Timer_running } = useTimerControls();


	//	-----	--------------------------------------------------------	--------------------------------------------------------	----
	//	-----	--------------------------------------------------------	--------------------------------------------------------	----


	const GuessLet = ({letter, state, className, showCursor}) => <div className={"letter-box " + className + (showCursor ? " cursor" : "")}>{letter}</div>

	const GuessRow = ({word, length, res, active, cursorPos}) => <div className={"letter-row" + (active ? " active" : "")}>
				{ Array.from({ length: length }).
						map( (_, i) => <GuessLet key={i} letter={word?.[i]} className={res?.[i]=='2' && 'lett-green' || res?.[i]=='1' && 'lett-yellow' || res?.[i]=='0' && 'lett-grey'} showCursor={active && i === cursorPos} /> )
				}
			</div>

	/*const InputRow = ({word, length}) => <div className="letter-row">
				<Input 
					value={word} 
					onChange={ (event, data) => { console.log('input onChange', data); setCurr_guess(data.value); } } 
					// size="huge"
					transparent
					focus
					className="guess-inp" 
					maxLength={WORD_LENGTH}
					style={{width: `${3.6*WORD_LENGTH}rem`, fontSize: '45px'}}
					id='inp_fld'
				/>
			</div>
	*/

	const KeybLett = ({letter, onCl, state, className}) => <button 
					onClick={ _=> onCl ? onCl(letter) : insertLetter(letter) } 
					className={"keyboard-button " + className + " " +(used_letts[letter]=='2'&&'key-green' || used_letts[letter]=='1'&&'key-yellow' || used_letts[letter]=='0'&&'key-grey' )}
				>{letter}</button>


	//	-----	--------------------------------------------------------	--------------------------------------------------------	----
	//	-----	--------------------------------------------------------	--------------------------------------------------------	----


	// console.log(GAME_WORD)

	const listenKeys = useCallback((e)=>{

		if (document.activeElement?.id == 'inp_fld')
			return

		const pressedKey = String(e.key)

		if (pressedKey === "Enter") {
			checkGuess()
			return
		}

		// console.log('keyboard-cont click', e.target, document.activeElement?.id);

		if (pressedKey === "Backspace") {
			deleteLetter()
			return
		}

		if (pressedKey && pressedKey.length == 1 && pressedKey.match(/[a-z]/gi)) 
			insertLetter(pressedKey)

	}, [curr_guess])

	if (KEYB_LISTN)
		useEffect(()=>{

			document.addEventListener('keyup', listenKeys)

			return () => {
				document.removeEventListener('keyup', listenKeys)
			}

		}, [listenKeys])


	/*useEffect( _=> {

			// initBoard();

			// initKeyboard();

			listenKeys();

		}, [])

	function init () {

	}*/


	/*const listenKeys__ = _ => {
		document.addEventListener("keyup", (e) => {

			const pressedKey = String(e.key)

			if (pressedKey === "Enter") {
				checkGuess()
				return
			}

			if (document.activeElement?.id == 'inp_fld')
				return

			// console.log('keyboard-cont click', e.target, document.activeElement?.id);

			if (pressedKey === "Backspace") {
				deleteLetter()
				return
			}

			let lett = pressedKey.match(/[a-z]/gi)
			if (!lett || lett.length > 1) {
				return
			} else {
				insertLetter(pressedKey)
			}
		})
	}*/

	function insertLetter (pressedKey) {

		if (curr_guess.length === WORD_LENGTH) 
			return

		pressedKey = pressedKey.toLowerCase();

		// console.log('insertLetter', curr_guess);

		setCurr_guess(curr_guess + pressedKey);

		if (!Timer_running()) {
			Timer_start();
			ON_STAT?.('start')
		}

		// setCurr_guess(prevGuess => prevGuess + pressedKey)
	}


	function deleteLetter () {

		// console.log('deleteLetter', curr_guess, curr_guess.slice(0, -1));

		setCurr_guess(prevGuess => prevGuess.slice(0, -1))

	}

	//	-----	--------------------------------------------------------	--------------------------------------------------------	----

	async function checkGuess () {


		// setCurr_guess( prevGuess => console.log('prevGuess', prevGuess) );

		// setCurr_guess( prevGuess => setGuess_arr( guess_arr.concat(prevGuess) ) );

		if (guess_arr.length+1 > NUMBER_OF_GUESSES) {
			toast.error("No more guesses!")
			return
		}

		if (curr_guess.length < WORD_LENGTH) {
			toast.error("Not enough letters!")
			return
		}

		if (DICT && !WORDS_DICT.includes(curr_guess)) {
			toast.error("Word not in list!")
			return
		}

		let match_res = '';

			Array.from({ length: WORD_LENGTH }).map( (_, i) => match_res = match_res.concat(
																					GAME_WORD[i] == curr_guess[i] && '2'
																					|| GAME_WORD.includes(curr_guess[i]) && '1'
																					|| '0'
																				) )		


		setUsed_letts(prev => {
			const updated = {...prev};
			for (var i = 0; i < curr_guess.length; i++)
				if (!updated[curr_guess[i]] || updated[curr_guess[i]]*1 < match_res[i]*1)
					updated[curr_guess[i]] = match_res[i];
			return updated;
		});

		DEBUG && console.log('checkGuess', GAME_WORD, curr_guess, match_res, guess_arr);

		const check_res = {w: curr_guess, r: match_res, t: Timer_now(), i:guess_arr.length+1}

		ON_CHECK?.(check_res)

		if (curr_guess == GAME_WORD) {
			// Array.from({ length: WORD_LENGTH }).map( (_, i) => match_res = match_res.concat('2') )
			Timer_stop()
			toast.success("You guessed right! Game over!")
			await ON_STAT?.('win')
			setStat('win')

		} else if (guess_arr.length+2 > NUMBER_OF_GUESSES) {
			Timer_stop()
			toast.error("You've run out of guesses! Game over!")
			// toast.info(`The right word was: "${GAME_WORD}"`)
			await ON_STAT?.('end')
			setStat('end')

		}

		setGuess_arr( guess_arr.concat( check_res ) )
		setCurr_guess( '' );

		return

		//	-----	--------------------------------------------------------	--------------------------------------------------------	----
		//	-----	--------------------------------------------------------	--------------------------------------------------------	----


		for (let i = 0; i < WORD_LENGTH; i++) {
			let letterColor = ''
			let box = row.children[i]
			let letter = currentGuess[i]

			let delay = 270 * i
			setTimeout(()=> {
				//flip box
				animateCSS(box, 'flipInX')
				//shade box
				// box.style.backgroundColor = letterColor
				// box.style.color = "white"
				box.classList.add('lett-'+letterColor)
				shadeKeyBoard(letter, letterColor)
			}, delay)
		}

	}

	//	-----	--------------------------------------------------------	--------------------------------------------------------	----
	//	-----	--------------------------------------------------------	--------------------------------------------------------	----

	const animateCSS = (element, animation, prefix = 'animate__') =>
		// We create a Promise and return it
		new Promise((resolve, reject) => {
			const animationName = `${prefix}${animation}`;
			// const node = document.querySelector(element);
			const node = element
			node.style.setProperty('--animate-duration', '0.3s');
			
			node.classList.add(`${prefix}animated`, animationName);

			// When the animation ends, we clean the classes and resolve the Promise
			function handleAnimationEnd(event) {
				event.stopPropagation();
				node.classList.remove(`${prefix}animated`, animationName);
				resolve('Animation ended');
			}

			node.addEventListener('animationend', handleAnimationEnd, {once: true});
		});

	//	-----	--------------------------------------------------------	--------------------------------------------------------	----
	//	-----	--------------------------------------------------------	--------------------------------------------------------	----


	return <Container >

		<h1> WeWordle game </h1>

		{game_pars?.name && (
			<div style={{ textAlign: 'center', marginBottom: '20px' }}>
				<h2>{game_pars.name}</h2>
			</div>
		)}

		{game_pars.desc && <p style={{ color: '#666', fontStyle: 'italic', textAlign: 'center' }}>{game_pars.desc}<br /></p>}

		{/*<div id="game-cont">
		</div>*/}

		<div id="guess-cont">
			{ guess_arr.map( (guess, i) => <GuessRow key={i} word={guess.w} res={guess.r} length={WORD_LENGTH} />) }

			{ guess_arr.length < NUMBER_OF_GUESSES &&
				stat == 'guessing' && <>
				{SHOW_INP_BXS && <GuessRow word={curr_guess} length={WORD_LENGTH} active={true} cursorPos={curr_guess.length} />}
				{SHOW_INP_FLD && 
					<div className="letter-row">
						<Input 
							value={curr_guess} 
							onChange={ (event, data) => setCurr_guess(data.value) } 
							onKeyPress={ e => (e.charCode==13 || e.code=="Enter") && checkGuess() } 
							// size="huge"
							transparent
							focus
							className="guess-inp" 
							maxLength={WORD_LENGTH}
							style={{width: `${3.6*WORD_LENGTH}rem`, fontSize: '45px'}}
							id='inp_fld'
						/>
					</div>
				}
			</> }
			{ Array.from({ length: NUMBER_OF_GUESSES-guess_arr.length-(stat == 'guessing' ? 1 : 0)}).
					map( (_, i) => <GuessRow key={i} word={''} length={WORD_LENGTH} />) }
		</div>

		{['win'].includes(stat) && 
			<>
				<br />
				<Leaderboard gid={ game_pars?.gid } type='game' />
			</>
		}

		{/* Timer and Dictionary indicator on same line */}
		<div className="timer-dict-row">
			<TimerDisplay />
			<span
				className="dict-indicator"
				style={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: '4px',
					padding: '3px 8px',
					borderRadius: '10px',
					fontSize: '12px',
					fontWeight: '500',
					background: DICT ? '#d4edda' : '#f8d7da',
					color: DICT ? '#155724' : '#721c24',
					opacity: 0.85
				}}
			>
				<Icon name='book' size='small' style={{ margin: 0 }} />
				Dictionary {DICT ? 'ON' : 'OFF'}
			</span>
		</div>

		<div id="keyboard-cont">
			<div className="first-row">
				{['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'].map( (letter, i) => <KeybLett key={i} letter={letter} />) }
			</div>
			<div className="second-row">
				{['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'].map( (letter, i) => <KeybLett key={i} letter={letter} />) }
			</div>
			<div className="third-row">
				{['z', 'x', 'c', 'v', 'b', 'n', 'm'].map( (letter, i) => <KeybLett key={i} letter={letter} />) }
				{['⇦'].map( (letter, i) => <KeybLett key={i} letter={letter} onCl={deleteLetter} />) }
				{['Enter'].map( (letter, i) => <KeybLett key={i} letter={letter} onCl={checkGuess} />) }
			</div>
		</div>

		<ToastContainer position="bottom-center" />
		{/*<div>
			<pre>{JSON.stringify(guess_arr, null, 4)}</pre>
		</div>*/}
		{/*<div>
			<pre>{JSON.stringify(used_letts, null, 4)}</pre>
		</div>*/}
	</Container>
}
 
export default Wordle;